import React, { useState, useEffect } from 'react';

const Overlay = ({ message, type, onConfirm, duration = 3000 }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (type === 'success') {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onConfirm) onConfirm(); // Call onConfirm when success overlay disappears
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [type, duration]);

  if (!isVisible) return null;

  const overlayClasses = `fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50`;
  const cardClasses = `p-6 rounded-lg shadow-lg text-white max-w-sm mx-auto text-center`;

  return (
    <div className={overlayClasses}>
      <div className={`${cardClasses} ${type === 'success' ? 'bg-green-500' : 'bg-red-600'}`}>
        <p className="text-lg font-semibold mb-4">{message}</p>
        {type === 'error' && (
          <button
            onClick={() => {
              setIsVisible(false);
              if (onConfirm) onConfirm();
            }}
            className="px-4 py-2 bg-white text-green-800 rounded hover:bg-gray-200 focus:outline-none"
          >
            OK
          </button>
        )}
      </div>
    </div>
  );
};

export default Overlay;


